import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';
import RoutesApp from '../../routes';

//Servicios
import { DeclaracionesService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import DJDUVSearch from './DJDUVSearch';

//Estilos
import right_arrow from '../../assets/imgs/next.png';

function DJDUVSearchContainer() {
    const { masters, SearchParameters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.DJDUVPage, [state.DJDUVPage]);

    const [loader, setLoader] = useState(false);
    const [tableData, setTableData] = useState(buildTableData());
    let apiTablePages;

    useEffect(() => {
        const getDJDUVSearchCuantity = async () => {
            try {
                setLoader(true);

                const DJDUVSearchCuantity =
                    await DeclaracionesService.totalRecords({
                        ...SearchParameters.declaraciones,
                        tipo: 8,
                    });

                if (DJDUVSearchCuantity) {
                    apiTablePages = DJDUVSearchCuantity.data;

                    getDJDUVSearch();
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getDJDUVSearchCuantity();
    }, [tablePage, SearchParameters.declaraciones]);

    async function getDJDUVSearch() {
        try {
            setLoader(true);

            const DJDUVSearch = await DeclaracionesService.search({
                ...SearchParameters.declaraciones,
                tipo: 8,
                pagina: tablePage,
            });

            if (DJDUVSearch) {
                setTableData(buildTableData(DJDUVSearch.data, apiTablePages));
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    }

    /**Funcion que crea el objeto para crear la tabla resultado del buscador de DJDUVs */
    function buildTableData(data = [], tablePages) {
        return {
            title: 'Declaraciones de DJDUV',
            headers: [
                'ID',
                'Viñedo',
                'Titulares',
                'Fecha',
                'Departamento',
                'Seccional',
                ' ',
            ],
            tablePages,
            pagination: 10,
            pageType: 'DJDUVPage',
            data:
                data.length > 0
                    ? data.map((dj) => {
                          return {
                              id: `${dj.serie}-DU-${dj.numero}`,
                              viniedo: dj.viniedo,
                              titulares: dj.titulares,
                              fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                              departamento: masters.Departments?.find(
                                  (ht) => ht.id === dj.departamento
                              )?.nombre.replaceAll('_', ' '),
                              kilosTotales: dj.seccional,
                              icons: (
                                  <div>
                                      <Link
                                          to={
                                              RoutesApp.Declaraciones
                                                  .cosechaProbable + dj.id
                                          }
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    }

    return loader ? <Spinner /> : <DJDUVSearch tableData={tableData} />;
}

export default DJDUVSearchContainer;
